import React from "react";
import { Modal, Input, Button, Typography, Divider, message } from "antd";
import {
  CopyOutlined,
  MailOutlined,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { useLanguage } from "../../../../context/LanguageContext";

const { Title, Paragraph, Text } = Typography;

const ShareFormModal = ({ open, onClose, form, qrCode }) => {
  const { language } = useLanguage();
  const t = translations[language] || translations["de"];
  if (!form && !open) return null;

  const link = `${window.location.origin}/feedbackform/${form._id}`;
  const iframeCode = `<iframe src="${link}" width="100%" height="600" style="border:none;"></iframe>`;

  const copy = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      message.success(t.copied);
    } catch {
      message.error(t.copyError);
    }
  };

  const downloadImage = (url) => {
    const link = document.createElement("a");
    link.href = url;
    link.download = `QRCode_${form.name || "Formular"}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal open={open} onCancel={onClose} footer={null} title={t.title}>
      <Typography>
        <Paragraph>{t.linkLabel}</Paragraph>
        <Input
          value={link}
          addonAfter={<CopyOutlined onClick={() => copy(link)} />}
          readOnly
        />
        <div className="flex gap-2 mt-2">
          <Button
            icon={<MailOutlined />}
            onClick={() =>
              window.open(
                `mailto:?subject=${encodeURIComponent(
                  form.name
                )}&body=${encodeURIComponent(link)}`
              )
            }
          >
            E-Mail
          </Button>

          <Button
            icon={<WhatsAppOutlined />}
            style={{ backgroundColor: "#25D366", color: "white" }}
            onClick={() =>
              window.open(
                `https://wa.me/?text=${encodeURIComponent(link)}`,
                "_blank"
              )
            }
          >
            WhatsApp
          </Button>
        </div>
        <Divider />

        <Paragraph>{t.iframeLabel}</Paragraph>
        <Input.TextArea value={iframeCode} autoSize={{ minRows: 3 }} readOnly />
        <Button
          icon={<CopyOutlined />}
          className="mt-2"
          onClick={() => copy(iframeCode)}
        >
          {t.copyButton}
        </Button>

        <Divider />
        <Paragraph>{t.qrLabel}</Paragraph>

        {qrCode?.qrCodeImage ? (
          <div className="flex flex-col items-center space-y-2">
            <img
              src={qrCode.qrCodeImage}
              alt="QR Code"
              style={{ maxWidth: 180, borderRadius: 8 }}
            />
            <Text type="secondary" className="text-center">
              {t.qrNote}
            </Text>
            <Button
              type="default"
              onClick={() => downloadImage(qrCode.qrCodeImage)}
            >
              {t.downloadQr || "QR-Code herunterladen"}
            </Button>
          </div>
        ) : (
          <Text type="secondary" italic>
            {t.qrMissing}
          </Text>
        )}
      </Typography>
    </Modal>
  );
};

const translations = {
  de: {
    title: "Formular teilen",
    linkLabel: "Direktlink zum Formular",
    iframeLabel: "In Webseite einbetten (iframe)",
    copyButton: "In Zwischenablage kopieren",
    qrLabel: "QR-Code",
    qrNote: "Dieser QR-Code führt direkt zum Formular.",
    copied: "Kopiert!",
    copyError: "Kopieren fehlgeschlagen",
    qrMissing: "Noch kein QR-Code vorhanden. Erstelle einen für dein Formular.",
  },
  en: {
    title: "Share form",
    linkLabel: "Direct link to the form",
    iframeLabel: "Embed in website (iframe)",
    copyButton: "Copy to clipboard",
    qrLabel: "QR Code",
    qrNote: "This QR code links to your form.",
    copied: "Copied!",
    copyError: "Copy failed",
    qrMissing: "No QR code yet. Create one for your form.",
  },
};

export default ShareFormModal;
